import "@fontsource/mansalva/400.css";
import "@fontsource/ubuntu/400.css";
import "@fontsource/ubuntu/400-italic.css";
import "@fontsource/ubuntu/700.css";
